import { render } from "./DetailCompany.vue?vue&type=template&id=3cf5989c&scoped=true"
import script from "./DetailCompany.vue?vue&type=script&lang=js"
export * from "./DetailCompany.vue?vue&type=script&lang=js"

import "./DetailCompany.vue?vue&type=style&index=0&id=3cf5989c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf5989c"]])

export default __exports__